import type { ComponentProps, ReactNode } from "react";
import { cn } from "@/shared/utils/cn";

export interface StatusBadgeProps extends ComponentProps<"span"> {
  children: ReactNode;
  tone?: "positive" | "pending" | "neutral" | "danger";
}

export function StatusBadge({ tone = "neutral", className, ...props }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex max-w-full items-center rounded-full px-2.5 py-1 text-xs font-bold leading-snug",
        tone === "positive" && "bg-matcha text-primary",
        tone === "pending" && "bg-warning-foreground text-warning",
        tone === "neutral" && "bg-muted text-muted-foreground",
        tone === "danger" && "bg-danger-surface text-danger",
        className,
      )}
      {...props}
    />
  );
}
